import './LoadingLayer.scss';

export { LoadingLayer as default, useSetLoading, useIsLoading } from './LoadingLayer';
